export default "/fonts/vendor/fontsource-roboto/files/roboto-all-400-italic.woff?63782d1445ad031af14dd9291835ed3d";